/* Max Series landing — synced from https://www.autelrobotics.com/productdetail/evo-max-series-old/ */
(function () {
  function bindMobileSubnav(page) {
    const toggle = page.querySelector('.flightxfj-list-mobilemenuaName');
    const menu = page.querySelector('.flightxfj-list-mobilemenu > ul');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.classList.toggle('is-open', open);
    });
  }

  function bindTabs(page) {
    const panels = page.querySelectorAll('.application-spe > .cc');
    if (panels.length < 2) return;

    function showTab(index) {
      panels.forEach((panel, i) => {
        panel.style.display = i === index ? '' : 'none';
        if (i === 0) panel.style.opacity = i === index ? '1' : '0';
      });
      page.querySelectorAll('.flightxfj-list-menuRight li a').forEach((a, i) => {
        a.classList.toggle('tab-active', i === index);
      });
      page.querySelectorAll('.flightxfj-list-mobilemenu li a').forEach((a, i) => {
        a.classList.toggle('active', i === index);
      });
    }

    page.querySelectorAll('.flightxfj-list-menuRight li').forEach((li, i) => {
      if (i > 1) return;
      li.addEventListener('click', (e) => {
        if (i < 2) {
          e.preventDefault();
          showTab(i);
        }
      });
    });

    page.querySelectorAll('.flightxfj-list-mobilemenu li').forEach((li, i) => {
      if (i > 1) return;
      li.addEventListener('click', (e) => {
        if (i < 2) {
          e.preventDefault();
          showTab(i);
        }
      });
    });

    if (location.hash === '#jsgg') showTab(1);
    else showTab(0);
  }

  function bindSpecsAccordion(page) {
    page.querySelectorAll('.insrecruit-list .rectue-top').forEach((top) => {
      top.addEventListener('click', () => {
        const li = top.closest('li');
        if (li) li.classList.toggle('cur');
      });
    });
  }

  function swiperReady(el) {
    return el && !el.swiper;
  }

  function initSwiper(el, options) {
    if (!swiperReady(el) || typeof window.Swiper === 'undefined') return null;
    try {
      return new window.Swiper(el, options);
    } catch (_) {
      return null;
    }
  }

  function bindMod3TabSwiper(page, tabSelector, swiperSelector) {
    const $ = window.jQuery;
    const swiperEl = page.querySelector(swiperSelector);
    const swiper = initSwiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: '5%',
      paginationClickable: true,
    });
    if (!$ || !swiper) return;

    $(page).find(tabSelector + ' li').on('mouseenter', function () {
      $(page).find(tabSelector + ' li').removeClass('on');
      $(this).addClass('on');
      const index = Number($(this).attr('data-index'));
      if (!Number.isNaN(index)) swiper.slideTo(index);
    });
  }

  function initYtListSwiper(page) {
    const $ = window.jQuery;
    const ytSwiperEl = page.querySelector('.new-mod3-cont .yt-list .swiper-container');
    if (!ytSwiperEl) return null;

    if (ytSwiperEl.swiper) {
      try {
        ytSwiperEl.swiper.destroy(true, true);
      } catch (_) {}
    }

    const wrapper = ytSwiperEl.querySelector('.swiper-wrapper');
    const slides = wrapper
      ? Array.from(wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'))
      : [];
    const slideCount = slides.length;
    const slidesPerView = 3;

    // Swiper 3 loop needs more slides than slidesPerView — clone once before init.
    if (slideCount > 0 && slideCount <= slidesPerView) {
      slides.forEach((slide) => {
        wrapper.appendChild(slide.cloneNode(true));
      });
    }

    const swiper = initSwiper(ytSwiperEl, {
      direction: 'horizontal',
      slidesPerView,
      slideToClickedSlide: true,
      centeredSlides: true,
      spaceBetween: '1.5%',
      loop: slideCount > 1,
      loopedSlides: slideCount,
      autoplay: false,
      initialSlide: Math.min(1, Math.max(0, slideCount - 1)),
      paginationClickable: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        971: {
          slidesPerView: 1,
          centeredSlides: true,
          loop: slideCount > 1,
          loopedSlides: slideCount,
        },
      },
      onInit(s) {
        s.update(true);
        syncYtListActiveItem(page, s);
      },
      onSlideChangeEnd(s) {
        syncYtListActiveItem(page, s);
      },
    });

    if ($ && swiper) {
      $(page).find('.yt-list .item').on('click', function () {
        const slide = this.closest('.swiper-slide');
        if (slide && swiper.clickedSlide !== slide) {
          const index = Array.prototype.indexOf.call(swiper.slides, slide);
          if (index >= 0) swiper.slideTo(index);
        }
        $(page).find('.yt-list .item').removeClass('on');
        $(this).addClass('on');
      });
    }

    if (swiper) {
      window.addEventListener('load', () => {
        swiper.update(true);
        syncYtListActiveItem(page, swiper);
      }, { once: true });
    }

    return swiper;
  }

  function syncYtListActiveItem(page, swiper) {
    page.querySelectorAll('.new-mod3-cont .yt-list .item').forEach((item) => {
      item.classList.remove('on');
    });
    const activeSlide = swiper.slides[swiper.activeIndex];
    const activeItem = activeSlide && activeSlide.querySelector('.item');
    if (activeItem) activeItem.classList.add('on');
  }

  function initSwipers(page) {
    initYtListSwiper(page);
    page.querySelectorAll('.swiper20').forEach((el) => {
      initSwiper(el, {
        slidesPerView: '1',
        centeredSlides: true,
        loop: true,
        spaceBetween: 10,
        pagination: el.querySelector('.swiper-pagination'),
        paginationClickable: true,
      });
    });

    page.querySelectorAll('.swiper21').forEach((el) => {
      initSwiper(el, {
        slidesPerView: '1',
        centeredSlides: true,
        loop: true,
        spaceBetween: 10,
        pagination: el.querySelector('.swiper-pagination'),
        paginationClickable: true,
      });
    });

    bindMod3TabSwiper(page, '.tabs1', '.mod3-sw1 .swiper-container');
    bindMod3TabSwiper(page, '.tabs2', '.mod3-sw2 .swiper-container');
    bindMod3TabSwiper(page, '.tabs3', '.mod3-sw3 .swiper-container');
  }

  function fixP17AccessorySpacing(page) {
    page.querySelectorAll('.p17 .evomax48-fd-ms').forEach((el) => {
      ['max-height', 'height', 'min-height', 'overflow', 'margin', 'padding'].forEach((prop) => {
        el.style.removeProperty(prop);
      });
    });
  }

  function initMaxSeriesPage() {
    const page = document.querySelector('.cs-max-series-page');
    if (!page) return;

    page.addEventListener('click', (event) => {
      if (event.target.closest('.flightxfj-list-menuLeft')) {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
    });

    bindMobileSubnav(page);
    bindTabs(page);
    bindSpecsAccordion(page);
    initSwipers(page);
    fixP17AccessorySpacing(page);
    window.setTimeout(() => fixP17AccessorySpacing(page), 300);

    if (window.WOW) {
      try {
        new window.WOW({ live: false }).init();
      } catch (_) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMaxSeriesPage);
  } else {
    initMaxSeriesPage();
  }
})();
